import React from "react";
import { Container } from "@material-ui/core";
import InvitePartner from "./components/invitePartner";
import { isUsMarket } from "utils/market";
import { isContentOnly } from "utils/appMode";
import { contentFeatures, navVisible } from "routes/content/contentFeatures";
import ManageTreatments from "./components/ManageTreatments";
import FRInvoices from "./components/FRInvoices";
import { BoxButton } from "shared";
import { useTranslation } from "react-i18next";
import { Area } from "types";
import { join } from "utils/misc";
import { Link } from "react-router-dom";
import { ViewComfy, Edit, NoteAdd, Assignment, Mail, GetApp, LocalPharmacy } from "@material-ui/icons";
import CareEventConfigurations from "./components/CareEventConfigurations";
import { InvitePhysician } from "./components/InvitePhysician";
import { InviteTherapist } from "./components/InviteTherapist";
import { InviteBillingAdmin } from "./components/InviteBillingAdmin";
import { InviteProviderPatient } from "./components/InviteProviderPatient";

const Other: React.VFC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Container maxWidth="sm">
        {!isContentOnly && (
          <>
            {isUsMarket && (
              <BoxButton component={Link} to={Area.UnclaimedMedicalReferrals} startIcon={<ViewComfy />}>
                {t("views.unclaimed_medical_referrals")}
              </BoxButton>
            )}
            {isUsMarket && <InvitePartner />}
            {isUsMarket && <InviteProviderPatient />}
            {isUsMarket && <InvitePhysician />}
            {isUsMarket && <InviteBillingAdmin />}
            {!isUsMarket && (
              <BoxButton component={Link} to={Area.UkReferralTracking} startIcon={<Assignment />}>
                {t("referral_tracking.title")}
              </BoxButton>
            )}
            {!isUsMarket && (
              <BoxButton component={Link} to={Area.UkReferralBatch} startIcon={<NoteAdd />}>
                {t("form.uk_referral_batch")}
              </BoxButton>
            )}
            {!isUsMarket && (
              <BoxButton component={Link} to={Area.UkReports} startIcon={<GetApp />}>
                {t("uk_reports.title")}
              </BoxButton>
            )}
            <InviteTherapist />
            <BoxButton component={Link} to={Area.Invitations} startIcon={<Mail />}>
              {t("views.invitations")}
            </BoxButton>
            <ManageTreatments />
            <FRInvoices />
            <BoxButton component={Link} to={join(Area.Registry, "referral-sources")} startIcon={<ViewComfy />}>
              {t("views.registry")}
            </BoxButton>
            <CareEventConfigurations />
            <BoxButton component={Link} to={Area.Payers} startIcon={<ViewComfy />}>
              {t("views.payers")}
            </BoxButton>
            <BoxButton component={Link} to={Area.Medications} startIcon={<LocalPharmacy />}>
              {t("views.medications")}
            </BoxButton>
            <BoxButton component={Link} to={Area.CreateContent_Exercises} startIcon={<Edit />}>
              {t("views.create_content")}
            </BoxButton>
          </>
        )}
        {contentFeatures.map(
          feature =>
            navVisible(feature.area) && (
              <BoxButton key={feature.area} component={Link} to={feature.area} startIcon={<feature.Icon />}>
                {t(feature.label)}
              </BoxButton>
            )
        )}
      </Container>
    </Container>
  );
};

export default Other;
